"use client";

import React, { useState } from "react";

interface CustomerSuccess {
  company: string;
  displayName: string;
  quote: string;
  results: {
    value: string;
    description: string;
  }[];
  ceo?: string;
  imageSrc?: string;
}

const customerSuccesses: CustomerSuccess[] = [
  {
    company: "Tec-Do",
    displayName: "Tec-Do",
    quote:
      "We switched to AI-generated UGC ads and saw results immediately—production time dropped by over 90%, costs fell from $20 to $2 per video, and engagement tripled compared to image-based creatives. Without changing a thing, we scaled faster and saw stronger performance at a fraction of the cost.",
    results: [
      { value: "90%", description: "Cost Reduction" },
      { value: "3X", description: "More Views" },
      { value: "97%", description: "Time Saved" },
    ],
  },
  {
    company: "Zumper",
    displayName: "Zumper",
    quote:
      "We produced over 300 social videos in a single quarter using AI-generated UGC. What used to require an entire creative team now takes just one editor—and we're saving $20K a month. It's helped us scale content, retain key clients, and build for a social-first future.",
    results: [
      { value: "$20,000", description: "saved per month" },
      { value: "300%", description: "videos made in 2 months" },
    ],
  },
  {
    company: "Whole Life Pet",
    displayName: "Whole Life Pet",
    quote:
      "We used to spend $3,000 and weeks of agency work for a single video. Now, we create branded videos in minutes for under $4 each. Our production capacity increased 50x, daily output is up 12x, and every message hits exactly how we want. It's changed how we market, completely.",
    results: [
      { value: "$2,900", description: "saved per video" },
      { value: "50x", description: "capacity increase" },
      { value: "12x", description: "daily speed" },
    ],
  },
  {
    company: "1MORE",
    displayName: "1MORE",
    quote:
      "We used to spend $3,000 to $15,000 and weeks coordinating with agencies and influencers for a single video. Now, we create high-quality branded videos in under 10 minutes for under $4 each. Our production speed is 30x faster, and we've saved over $10,000 per video. Our key metrics have surged, with a 200% increase in purchases, a 47.86% boost in CTR, and a 158.93% rise in link clicks. AI-generated UGC has transformed how we create and scale content.",
    results: [
      { value: "$10,000", description: "saved per video" },
      { value: "30x", description: "faster production" },
      { value: "200%", description: "more purchases" },
    ],
  },
];

export default function CustomerSuccessSection() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <section className="bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-center mb-12">Brand Results</h2>

        {/* Company logos at the top */}
        <div className="flex flex-wrap justify-center items-center gap-16 mb-12">
          {customerSuccesses.map((success, index) => (
            <button
              key={index}
              onClick={() => setActiveTab(index)}
              className={`text-xl font-medium transition-all px-2 cursor-pointer border-b-2 pb-1 ${
                activeTab === index
                  ? "text-gray-800 border-indigo-600"
                  : "text-gray-400 hover:text-gray-600 border-transparent hover:border-indigo-600"
              }`}
            >
              {success.company}
            </button>
          ))}
        </div>

        <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-start justify-center">
          {/* Left side - Image */}
          {/* 
          <div className="md:w-1/4">
            <div className="rounded-lg overflow-hidden bg-gray-100 aspect-[4/5] relative shadow-md">
              {customerSuccesses[activeTab].imageSrc ? (
                <Image
                  src={customerSuccesses[activeTab].imageSrc}
                  alt={`${customerSuccesses[activeTab].company} case study`}
                  fill
                  className="object-cover"
                />
              ) : (
                <div className="relative w-full h-full flex items-end">
                  <div className="absolute top-4 left-4 bg-indigo-600 text-white text-xs font-bold py-1 px-2 rounded-full">
                    Extensions
                  </div>
                  <div className="p-4 text-center text-sm w-full bg-black bg-opacity-30 text-white">
                    You can find this and more on travdelight.com
                  </div>
                </div>
              )}
            </div>
          </div>
          */}

          {/* Right side - Content */}
          <div className="md:w-3/4 max-w-3xl mx-auto">
            <blockquote className="text-gray-700 text-lg mb-8">
              "{customerSuccesses[activeTab].quote}"
            </blockquote>

            {customerSuccesses[activeTab].ceo && (
              <p className="text-gray-500 text-sm mb-8">
                - {customerSuccesses[activeTab].ceo}
              </p>
            )}

            {/* Results with larger numbers */}
            <div className="grid grid-cols-3 gap-6 my-8">
              {customerSuccesses[activeTab].results.map((result, idx) => (
                <div key={idx} className="text-center">
                  <p className="text-indigo-600 font-bold text-4xl mb-1">
                    {result.value}
                  </p>
                  <p className="text-gray-600 text-sm">{result.description}</p>
                </div>
              ))}
            </div>

            <div className="mt-6">
              {/* 
              <a
                href="#"
                className="text-indigo-600 font-medium flex items-center text-sm"
              >
                <span>Read full case study</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 ml-1"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </a>
              */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
